export const COLUMN_DEFAULT = {
    label:  "",
    value:  "",
    cards:  [],
}

export const CARD_DEFAULT = {
    id:             '',
    name:           '',
    description:    '',
};
